import React, { type ReactNode } from 'react';

import { Box, Stack, Tooltip, Typography } from '@mui/material';

import PromoFeatureAccessChips from './PromoFeatureAccessChips';
import { findPromoFeatureIndicator } from './PromoTester/promoFeatureIndicators';

type ConfigurationItem = { icon: ReactNode; label: string };

interface Props {
  feature: NonNullable<ReturnType<typeof findPromoFeatureIndicator>>;
  configurationItems: ReadonlyArray<ConfigurationItem>;
}

function getFeatureStatusLabel(feature: Props['feature']): string {
  if (feature.isOnlyTest) {
    return 'Test only';
  }
  return feature.docType === 'feature' ? 'Available' : 'Experimental';
}

export default function PromoFeatureHeader({ feature, configurationItems }: Props) {
  return (
    <Stack spacing={0.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <Box>
          <Typography component="h3" variant="subtitle1">
            {feature.displayName}
          </Typography>
          <Typography color="text.secondary" variant="body2">
            {getFeatureStatusLabel(feature)}
          </Typography>
        </Box>
        <Stack direction="row" alignItems="center" spacing={0.25} flexWrap="wrap">
          {configurationItems.map((item) => (
            <Tooltip key={item.label} title={item.label}>
              <Box component="span" aria-label={item.label} sx={{ display: 'inline-flex' }}>
                {item.icon}
              </Box>
            </Tooltip>
          ))}
        </Stack>
      </Stack>
      <PromoFeatureAccessChips feature={feature} />
    </Stack>
  );
}
